import { LoaderSolidV6 } from "@shared/v2/Icomoon";
import Typography from "@shared/v2/Typography";
import { useEffect } from "react";
import { Product } from "./ProductCard";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

interface ProcessingPurchaseProps {
  onSuccess: () => void;
  product: Product;
}

const ProcessingPurchase: React.FC<ProcessingPurchaseProps> = ({ onSuccess, product }) => {
  useEffect(() => {
    caseTransformingAxios
      .post("/products", product)
      .then(() => {
        onSuccess();
      })
      .catch(() => {
        // Handle error
      });
  }, [product]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-[16px]">
      <div className="tw-flex tw-items-center tw-gap-[8px]">
        {/* @ts-expect-error props */}
        <Typography variant="headline1">Processing purchase...</Typography>
        <LoaderSolidV6 size="xxl" className="tw-animate-spin" />
      </div>
      {/* @ts-expect-error props */}
      <Typography>
        Sit tight while we process your payment and confirm your subscription. This shouldn’t take long...
      </Typography>
    </div>
  );
};

export default ProcessingPurchase;
